var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConditional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 57.33 57.33",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.76 41.15h-4.2v-9.68a14.69 14.69 0 01-7.48-5v14.7H7.89c-.76 0-1 .52-.61 1.14l7.79 9.52a.86.86 0 001.53 0l7.77-9.53c.42-.63.14-1.15-.61-1.15z",
    fill: "#6cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.52 25.08L42 17.31c-.63-.42-1.14-.14-1.14.62v4.42l-16.33-.14c-5-.05-5.74-3.7-5.72-5.86l.12-10.74L12 5.53l-.12 10.74c-.08 7.61 5 12.78 12.57 12.86l16.4.14v4.53c0 .75.51 1 1.14.6l9.52-7.79a.86.86 0 00.01-1.53z",
    fill: "#3061ab"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYuOCIgaGVpZ2h0PSI3Ni44IiB2aWV3Qm94PSIwIDAgNTcuMzMgNTcuMzMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIzLjc2IDQxLjE1aC00LjJ2LTkuNjhhMTQuNjkgMTQuNjkgMCAwMS03LjQ4LTV2MTQuN0g3Ljg5Yy0uNzYgMC0xIC41Mi0uNjEgMS4xNGw3Ljc5IDkuNTJhLjg2Ljg2IDAgMDAxLjUzIDBsNy43Ny05LjUzYy40Mi0uNjMuMTQtMS4xNS0uNjEtMS4xNXoiIGZpbGw9IiM2NmNjZmYiLz48cGF0aCBkPSJNNTEuNTIgMjUuMDhMNDIgMTcuMzFjLS42My0uNDItMS4xNC0uMTQtMS4xNC42MnY0LjQybC0xNi4zMy0uMTRjLTUtLjA1LTUuNzQtMy43LTUuNzItNS44NmwuMTItMTAuNzRMMTIgNS41M2wtLjEyIDEwLjc0Yy0uMDggNy42MSA1IDEyLjc4IDEyLjU3IDEyLjg2bDE2LjQuMTR2NC41M2MwIC43NS41MSAxIDEuMTQuNmw5LjUyLTcuNzlhLjg2Ljg2IDAgMDAuMDEtMS41M3oiIGZpbGw9IiMzMDYxYWIiLz48L3N2Zz4K";
export { SvgConditional as ReactComponent };